import { useState } from "react"
import cn from "classnames"
import richText from "utilities/richText"
import Info from "public/assets/tooltip.svg"

function SizeSelect({ petSize, setPetSize, petSizes }) {
  return (
    <form action="" className="pb-6 bg-green-sea text-black py-4 pl-5 border-gray-dark border-2">
      <label className="block text-s2 md:text-m1 font-bold uppercase leading-9" htmlFor="pet-size">
        Please select your dog&apos;s size:
      </label>
      <select name="size" id="pet-size" className="p-2" value={petSize} onChange={(e) => setPetSize(e.target.value)}>
        {petSizes.map((size) => (
          <option key={size.value} value={size.value}>
            {size.name}
          </option>
        ))}
      </select>
    </form>
  )
}

const dogSizes = {
  toy: "Toy Breed",
  small: "Small Dog",
  medium: "Medium",
  large: "Large",
  x_large: "Extra Large",
}

function Chart({ heading, rows, additional_info, petSizes, isOneChart }) {
  const [petSize, setPetSize] = useState("small")
  const isPricingBySize = rows.some((row) => row.component === "chart_service_item")

  return (
    <div className={cn("basis-1/2", { "mx-auto": isOneChart })}>
      <h3 className="text-white pb-2">{heading}</h3>
      {isPricingBySize && <SizeSelect petSize={petSize} setPetSize={setPetSize} petSizes={petSizes} />}
      <div className="grid grid-cols-[1fr,auto]">
        <h4 className="bg-green-sea text-black py-4 pl-5 text-s2 md:text-m1 uppercase border-gray-dark border-2">
          Service {isPricingBySize && <span>({dogSizes[petSize]})</span>}
        </h4>
        <h4 className="bg-green-sea text-black py-4 px-5 text-s2 md:text-m1 uppercase border-gray-dark border-2">
          Charge
        </h4>
        {rows.map((row) => {
          const priceToDisplay = row.prices?.find((price) => price.size === petSize)
          return (
            <>
              <div className="bg-white text-s1 border-gray-dark border-2 py-2 px-5 uppercase flex items-center justify-between">
                {row.service}
                {richText(row.tooltip) ? (
                  <div className="group relative">
                    <Info className="ml-2 w-6 aspect-square" />
                    <div className="hidden group-hover:block group-active:block normal-case prose-p:text-s1 absolute right-1/2 translate-x-1/2 lg:right-0 lg:translate-x-0 bg-green-apple max-w-xs w-max text-black py-2 px-6 leading-5 shadow-lg z-50 mt-2">
                      {richText(row.tooltip)}
                    </div>
                  </div>
                ) : null}
              </div>
              {
                <div className="bg-white text-s1 border-gray-dark border-2 py-2 pl-5">
                  ${priceToDisplay !== undefined ? priceToDisplay.price : row.charge}
                </div>
              }
            </>
          )
        })}
      </div>
      {richText(additional_info) ? (
        <div className="text-white pt-4 prose-p:text-s2">{richText(additional_info)}</div>
      ) : null}
    </div>
  )
}

export default function TwoChartSection({ blok }) {
  const isOneChart = blok.charts.length < 2
  return (
    <section className="bg-grayPawprint py-12 px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-white text-center prose-h2:uppercase max-w-3xl mx-auto pb-4">
          {richText(blok.intro_content)}
        </div>
        <div className="flex flex-col md:flex-row gap-8">
          {blok.charts.map((chart, idx) => (
            <Chart {...chart} key={idx} petSizes={blok.petSizes} isOneChart={isOneChart} />
          ))}
        </div>
      </div>
    </section>
  )
}
